(function() {
  'use strict';

  /* jshint undef: true */
  /* global _:false */
  angular
    .module('linshare.authentication')
    .constant('_', _);
})();
